import { useState } from 'react';

// The brand strip at the top of a product card — the passport's brand header
// scaled to card size. Lifted out of UserCollection so Discover renders the same
// strip from the same code rather than a second copy that drifts.
//
// Takes whatever shape the caller has, so long as it carries the brand fields:
// an owned piece from /api/user/products, or a Discover card from
// /api/user/discover. Falls back logo -> wordmark -> nothing, so a brand with no
// header logo still reads as itself.
const CardBrandHeader = ({ p }) => {
    const [logoFailed, setLogoFailed] = useState(false);
    const label = p.brand_title || p.brand_name;
    if (!label && !p.brand_header_logo_url) return null;

    const showLogo = p.brand_header_logo_url && !logoFailed;
    const logo = (
        <img
            className="collection-card-brandhead-logo"
            src={p.brand_header_logo_url}
            alt={label || 'Brand'}
            onError={() => setLogoFailed(true)}
        />
    );

    return (
        <div className="collection-card-brandhead">
            {showLogo ? (
                p.brand_header_logo_bg_color ? (
                    <div
                        className="collection-card-brandhead-logo-wrap"
                        style={{ backgroundColor: p.brand_header_logo_bg_color }}
                    >{logo}</div>
                ) : logo
            ) : (
                <span style={{ color: p.brand_text_color || p.brand_color || undefined,
                               fontFamily: p.brand_font ? `'${p.brand_font}', sans-serif` : undefined }}>
                    {label}
                </span>
            )}
        </div>
    );
};

export default CardBrandHeader;
